module.exports = __webpack_public_path__ + "static/media/alien-desktop.825579ae.png";